module.exports = __webpack_public_path__ + "img/sn.5a3a015c.svg";